export default class {
  /**
   * コンストラクタ
   *
   * @param {Element} element 対象要素
   */
  constructor (element) {
    this.element = element
    this.target = {}
    this.content = {}
    this.dismissButtons = {}
    this.isShown = false

    this.init()
    this.handleEvents()
  }

  /**
   * 初期化
   */
  init () {
    this.target = document.getElementById(this.element.dataset.target.replace(/#/, ''))
    this.content = this.target.querySelector('.modal__inner')
    this.dismissButtons = this.target.querySelectorAll('[data-dismiss="modal"]')
  }

  /**
   * イベントリスナーの設定
   */
  handleEvents () {
    this.element.addEventListener('click', this.onClickElement.bind(this))
    this.target.addEventListener('click', this.onClickTarget.bind(this))
    this.content.addEventListener('click', this.onClickContent.bind(this))
    Array.prototype.forEach.call(this.dismissButtons, el => {
      el.addEventListener('click', this.onClickDismissButton.bind(this))
    })
    document.addEventListener('keydown', this.onKeydown.bind(this))
  }

  /**
   * 表示
   */
  show () {
    this.isShown = true

    this.target.classList.add('is-active')

    document.documentElement.style.overflow = 'hidden'

    this.target.setAttribute('aria-hidden', false)
  }

  /**
   * 非表示
   */
  hide () {
    this.isShown = false

    this.target.classList.remove('is-active')

    document.documentElement.style.overflow = ''

    this.target.setAttribute('aria-hidden', true)
  }

  /**
   * 表示・非表示のトグル
   *
   * @returns {undefined}
   */
  toggle () {
    return this.isShown ? this.hide() : this.show()
  }

  /**
   * 対象要素クリック時
   */
  onClickElement () {
    this.toggle()
  }

  /**
   * 背景クリック時
   */
  onClickTarget () {
    this.hide()
  }

  /**
   * コンテンツクリック時
   */
  onClickContent (e) {
    e.stopPropagation()
  }

  /**
   * 閉じるボタンクリック時
   */
  onClickDismissButton () {
    this.hide()
  }

  /**
   * キー押下時
   *
   * @param {KeyboardEvent} e イベントオブジェクト
   */
  onKeydown (e) {
    if (~e.key.indexOf('Esc')) {
      this.hide()
    }
  }
}



// WEBPACK FOOTER //
// ./src/komachi-official/assets/scripts/modules/Modal.js